import React from 'react';
import * as PropTypes from 'prop-types';
import { Badge } from 'react-bootstrap';

const RevisionStatus = ({ status, ...other }) => {
  switch (status) {
    case 'working':
      return (
        <Badge {...other} bg="info">
          WORKING COPY
        </Badge>
      );
    case 'invalid':
      return (
        <Badge {...other} bg="danger">
          OUT OF SPEC
        </Badge>
      );
    case 'tested':
      return (
        <Badge {...other} bg="success">
          IN SPEC
        </Badge>
      );
    case 'staged':
      return (
        <Badge {...other} bg="warning">
          STAGED
        </Badge>
      );
    default:
      return <Badge {...other}>{this.props.status}</Badge>;
  }
};

RevisionStatus.propTypes = {
  status: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default RevisionStatus;
